/*
 * Quick order: quantities across sizes and colours, priced on the total.
 *
 * The grid is the only place the customer sees the whole order at once, so it
 * has to price it the way the factory does — one run, one break — rather than
 * pricing each size on its own. Blazon works out the price; this collects the
 * rows and shows what they add up to.
 */
(function () {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  function start() {
    var grid = document.querySelector('[data-sb-bulk]');
    if (!grid) return;

    var panel = document.querySelector('[data-sb-panel]');
    var pricing = panel ? JSON.parse(panel.querySelector('[data-sb-pricing]').textContent || 'null') : null;
    var moq = parseInt(grid.dataset.moq, 10) || 1;
    var addButton = grid.querySelector('[data-sb-bulk-add]');
    var errorBox = grid.querySelector('[data-sb-bulk-error]');
    var fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' });

    function rows() {
      return [].slice.call(grid.querySelectorAll('[data-sb-bulk-qty]'))
        .map(function (input) {
          return { variantId: input.dataset.variantId, quantity: parseInt(input.value, 10) || 0 };
        })
        .filter(function (row) { return row.quantity > 0; });
    }

    function unitCentsFor(total) {
      if (!pricing) return null;
      for (var i = 0; i < pricing.tiers.length; i++) {
        var t = pricing.tiers[i];
        if (total >= t.min && (t.max === null || total <= t.max)) return t.price_cents;
      }
      return pricing.base_cents;
    }

    function render() {
      var chosen = rows();
      var total = chosen.reduce(function (sum, r) { return sum + r.quantity; }, 0);
      var unit = unitCentsFor(total);

      grid.querySelector('[data-sb-bulk-units]').textContent = total.toLocaleString() + (total === 1 ? ' unit' : ' units');
      grid.querySelector('[data-sb-bulk-price]').textContent =
        total && unit ? fmt.format((unit * total) / 100) + ' · ' + fmt.format(unit / 100) + ' each' : '';

      var note = grid.querySelector('[data-sb-bulk-note]');
      if (total === 0) {
        note.textContent = 'Minimum order ' + moq.toLocaleString() + ' units in total.';
      } else if (total < moq) {
        note.textContent = 'Add ' + (moq - total).toLocaleString() + ' more to reach the ' + moq.toLocaleString() + '-unit minimum.';
      } else {
        // Naming the next break is what turns a 200-unit order into a 250.
        var next = pricing && pricing.tiers.filter(function (t) { return t.min > total; })[0];
        note.textContent = next
          ? 'Add ' + (next.min - total).toLocaleString() + ' more → ' + fmt.format(next.price_cents / 100) + ' each'
          : 'Best price reached.';
      }
      addButton.disabled = total < moq;
    }

    grid.addEventListener('input', function (e) {
      if (e.target.matches('[data-sb-bulk-qty]')) render();
    });

    addButton.addEventListener('click', async function () {
      errorBox.hidden = true;
      addButton.disabled = true;
      var original = addButton.textContent;
      addButton.textContent = 'Adding…';
      try {
        var prepared = await fetch('/apps/blazon/api/bulk-prepare', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ productId: grid.dataset.productId, rows: rows() }),
        }).then(function (r) { return r.json(); });
        if (!prepared.lines) throw new Error(prepared.error || 'Could not price this order.');

        var added = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: prepared.lines }),
        });
        if (!added.ok) throw new Error('The cart did not accept these items.');
        window.location.href = '/cart';
      } catch (e) {
        errorBox.textContent = e.message;
        errorBox.hidden = false;
        addButton.disabled = false;
        addButton.textContent = original;
      }
    });

    render();
  }
})();
